import {
  Box,
  CircularProgress,
  Container,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Searchbar from '../SearchBar';
import { LoadingButton } from '@mui/lab';
import Iconify from '../Iconify';
import { api } from 'src/Api';

const ExistingCustomerTable = ({ getdata, customerdata, onclick }) => {
  const [loading, setloading] = useState(false);
  const [searchval, setsearchval] = useState('');
  const [customerlist, setcustomerlist] = useState([]);
  const [isActive, setisActive] = useState(null);

  const token = localStorage.getItem('token');

  console.log('cutomer data id ', customerdata);

  useEffect(() => {
    if (customerdata) {
      HandleGetCustomers();
    }
  }, []);

  const HandleGetCustomers = (value) => {
    setloading(true);
    console.log('search ', searchval);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    formData.append('service_id', customerdata?.serviceid);
    formData.append('sub_service_id', customerdata?.subserviceid);
    searchval && formData.append('search', value ? '' : searchval);
    fetch(api.get_existing_customers, {
      headers: myHeaders,
      body: formData,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          console.log('result of existing screen =======', result);

          setcustomerlist(result?.data);
        } else {
          console.log('Error:', result.message);
        }
      })
      .catch((error) => {
        console.log('Fetch error:', error);
      })
      .finally(() => {
        setloading(false);
      });
  };

  return (
    <Container>
      <Box
        mt={2}
        // p={2}
        style={{
          flexDirection: 'row',
          display: 'flex',
          flex: 1,
          justifyContent: 'space-between'
        }}
        className="top_options"
      >
        <Searchbar
          width={'90%'}
          value={searchval}
          setFunction={(val) => {
            setsearchval(val);
          }}
          onClickSearch={() => {
            setsearchval('');
            customerlist.length = 0;
            HandleGetCustomers('null');
          }}
          placeholder="Search"
          onEnter={() => {}}
        />
        <LoadingButton
          style={{ width: '15%', marginLeft: '2.5%' }}
          // loading={serachloading}
          variant="contained"
          onClick={() => {
            customerlist.length = 0;
            HandleGetCustomers();
          }}
          className="width_full"
        >
          <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
        </LoadingButton>
      </Box>

      <TableContainer
        component={''}
        sx={{
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          mt: 2,
          mb: 2,
          minWidth: 600
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontSize: '12px', color: '#f00001', width: 300 }}>
                Customer Name
              </TableCell>
              <TableCell sx={{ fontSize: '12px', color: '#f00001', width: 300 }}>
                Customer Email
              </TableCell>
              <TableCell sx={{ fontSize: '12px', color: '#f00001', width: 250 }}>Contact</TableCell>
              {/* <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Action</TableCell> */}
            </TableRow>
          </TableHead>

          {!loading && customerlist?.length !== 0 && (
            <TableBody
              sx={{
                '& .MuiTableRow-root:hover': {
                  backgroundColor: '#ffe5ec'
                }
              }}
            >
              {customerlist?.map((item, index) => (
                <TableRow
                  onClick={() => {
                    setisActive(index);
                    getdata({
                      name: item.customer_name,
                      email: item?.email,
                      contact: item?.contact
                    });
                    onclick();
                  }}
                >
                  <TableCell scope="row" padding="normal" style={{ width: 300 }}>
                    {/* <Stack direction="row" alignItems="center" spacing={1} style={{ width: 150 }}> */}
                    {/* <Box style={{ display: 'flex', flexDirection: 'column', width: 120 }}> */}
                    <Typography variant="subtitle2" flexWrap={'wrap'}>
                      {item.customer_name === 'undefined' ? 'N/A' : item.customer_name}
                    </Typography>
                    {/* </Box> */}
                    {/* </Stack> */}
                  </TableCell>

                  <TableCell scope="row" padding="normal" sx={{ width: 300 }}>
                    <Typography sx={{ fontSize: 12 }}>{item?.email || '-'}</Typography>
                  </TableCell>

                  <TableCell
                    scope="row"
                    // padding="normal"
                    sx={{ width: 250 }}
                  >
                    <Typography style={{ fontSize: 12 }}>{item?.contact || '-'}</Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}

          {loading && (
            <TableBody>
              <TableRow>
                <TableCell align="center" colSpan={4} sx={{ py: 3 }}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            </TableBody>
          )}

          {/* empty list */}
          {customerlist?.length == 0 && !loading && (
            <TableBody>
              <TableRow>
                <TableCell align="center" colSpan={4} sx={{ py: 3 }}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Typography variant="h6" gutterBottom color={'#f90001'}>
                      Customers not found!
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </Container>
  );
};

export default ExistingCustomerTable;
